import React, { useEffect, useState, useRef } from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { BookOpenIcon, CheckIcon, ClockIcon, AwardIcon, UsersIcon, BuildingIcon, ShieldCheckIcon, BarChartIcon, FileTextIcon, DownloadIcon, ChevronRightIcon, ChevronDownIcon, StarIcon, PlayCircleIcon, CheckCircleIcon, BadgeCheckIcon, ArrowRightIcon, PlusIcon, MinusIcon, UserIcon, LockIcon, GraduationCapIcon, CreditCardIcon, TrendingUpIcon, LightbulbIcon, BrainIcon, ThumbsUpIcon, MessageCircleIcon, AlertCircleIcon, UtensilsIcon, WashingMachineIcon, ThermometerIcon, ShieldIcon } from 'lucide-react';
export const CoursePage = () => {
  return <div className="flex flex-col min-h-screen w-full bg-white text-charcoal" data-id="element-418">
      <Header data-id="element-419" />
      <main className="flex-grow" data-id="element-420">
        <HeroSection data-id="element-421" />
        <TrustBanner data-id="element-422" />
        <CourseHighlights data-id="element-423" />
        <CourseOverview data-id="element-424" />
        <WhyChooseUs data-id="element-425" />
        <LearningOutcomes data-id="element-426" />
        <CourseCurriculum data-id="element-427" />
        <EnrollmentOptions data-id="element-428" />
        <CertificationSection data-id="element-429" />
        <TestimonialsSection data-id="element-430" />
        <FaqSection data-id="element-431" />
        <CtaSection data-id="element-432" />
      </main>
      <Footer data-id="element-433" />
    </div>;
};
const HeroSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);
  useEffect(() => {
    setIsVisible(true);
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
      }
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  return <section ref={sectionRef} className="relative pt-28 pb-20 md:pt-36 md:pb-28 overflow-hidden" data-id="element-434">
      {/* Background with enhanced overlay */}
      <div className="absolute inset-0 z-0" data-id="element-435">
        <img src="https://images.unsplash.com/photo-1581349485608-9469926a8e5e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80" alt="Professional Kitchen Environment" className="w-full h-full object-cover" data-id="element-436" />
        <div className="absolute inset-0 bg-gradient-to-r from-charcoal/95 via-charcoal/85 to-charcoal/75" data-id="element-437"></div>
        <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-[0.03] mix-blend-soft-light" data-id="element-438"></div>
      </div>
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-439">
        <div className="max-w-3xl" data-id="element-440">
          <div className={`transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`} data-id="element-441">
            <div className="inline-flex items-center px-4 py-2 rounded-full bg-teal/20 backdrop-blur-sm border border-teal/30 mb-6" data-id="element-442">
              <BadgeCheckIcon className="h-4 w-4 text-aqua mr-2" data-id="element-443" />
              <span className="text-white/90 text-sm font-medium" data-id="element-444">
                Accredited & Industry Recognized
              </span>
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-white leading-tight" data-id="element-445">
              Level 1 Food Safety{' '}
              <span className="text-gradient bg-gradient-to-r from-teal to-aqua bg-clip-text text-transparent" data-id="element-446">
                Certification
              </span>
            </h1>
            <p className="text-xl text-white/90 mb-8 leading-relaxed" data-id="element-447">
              Essential training for anyone who handles food. Start immediately,
              learn at your own pace, and get certified today with our{' '}
              <span className="font-semibold text-white" data-id="element-448">
                100% online course with instant access
              </span>
              .
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8" data-id="element-449">
              <div className="flex items-center bg-white/10 backdrop-blur-sm px-4 py-3 rounded-lg" data-id="element-450">
                <ClockIcon className="h-5 w-5 text-aqua mr-3 flex-shrink-0" data-id="element-451" />
                <span className="text-white" data-id="element-452">Complete in 2 Hours</span>
              </div>
              <div className="flex items-center bg-white/10 backdrop-blur-sm px-4 py-3 rounded-lg" data-id="element-453">
                <AwardIcon className="h-5 w-5 text-aqua mr-3 flex-shrink-0" data-id="element-454" />
                <span className="text-white" data-id="element-455">CPD Certified</span>
              </div>
              <div className="flex items-center bg-white/10 backdrop-blur-sm px-4 py-3 rounded-lg" data-id="element-456">
                <BookOpenIcon className="h-5 w-5 text-aqua mr-3 flex-shrink-0" data-id="element-457" />
                <span className="text-white" data-id="element-458">Interactive Modules</span>
              </div>
            </div>
            <div className="flex items-center bg-white/10 backdrop-blur-sm p-4 rounded-lg mb-8 max-w-xl" data-id="element-459">
              <div className="flex-1" data-id="element-460">
                <div className="flex items-center" data-id="element-461">
                  <StarIcon className="h-5 w-5 text-amber-400 mr-2" data-id="element-462" />
                  <span className="text-white font-medium" data-id="element-463">
                    Student Success Rate
                  </span>
                </div>
                <div className="mt-2 flex items-center" data-id="element-464">
                  <div className="w-full bg-white/20 rounded-full h-2.5" data-id="element-465">
                    <div className="bg-gradient-to-r from-teal to-aqua h-2.5 rounded-full" style={{
                    width: '97%'
                  }} data-id="element-466"></div>
                  </div>
                  <span className="ml-3 text-2xl font-bold text-white" data-id="element-467">
                    97%
                  </span>
                </div>
                <span className="text-white/60 text-sm mt-1 block" data-id="element-468">
                  Over 10,000 successful graduates
                </span>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-4 mb-8" data-id="element-469">
              <a href="#individual-enrollment" className="px-6 py-3.5 bg-teal text-white font-medium rounded-lg hover:bg-gradient-to-r hover:from-teal hover:to-aqua transition-all duration-300 text-center shadow-lg flex items-center justify-center" data-id="element-470">
                Enroll Now - Just €19
                <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-471" />
              </a>
              <a href="#preview-module" className="px-6 py-3.5 bg-transparent text-white font-medium rounded-lg border-2 border-white hover:bg-white/10 transition-all duration-300 text-center flex items-center justify-center" data-id="element-472">
                <PlayCircleIcon className="mr-2 h-5 w-5" data-id="element-473" />
                Preview Course
              </a>
            </div>
            {/* Money Back Guarantee Banner */}
            <div className="bg-gradient-to-r from-amber-400/90 to-amber-500/90 rounded-lg p-4 shadow-lg border border-amber-300 animate-pulse" data-id="element-474">
              <div className="flex items-center" data-id="element-475">
                <div className="w-12 h-12 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center mr-4 flex-shrink-0" data-id="element-476">
                  <ShieldIcon className="h-6 w-6 text-white" data-id="element-477" />
                </div>
                <div data-id="element-478">
                  <h3 className="font-bold text-white text-lg" data-id="element-479">
                    100% Acceptance Guarantee
                  </h3>
                  <p className="text-white/90" data-id="element-480">
                    If your certificate is not accepted by regulators or
                    enforcement bodies, we'll refund your purchase in full.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
const TrustBanner = () => {
  return <section className="py-4 bg-gray-50 border-y border-gray-200" data-id="element-481">
      <div className="container mx-auto px-4" data-id="element-482">
        <div className="flex flex-wrap items-center justify-center md:justify-between gap-6 text-center md:text-left" data-id="element-483">
          <p className="text-charcoal/70 font-medium" data-id="element-484">
            Trusted by leading food businesses across Europe:
          </p>
          <div className="flex flex-wrap justify-center gap-8" data-id="element-485">
            <div className="text-charcoal/80 font-semibold" data-id="element-486">FoodServe Ltd</div>
            <div className="text-charcoal/80 font-semibold" data-id="element-487">Euro Catering</div>
            <div className="text-charcoal/80 font-semibold" data-id="element-488">Fresh Market</div>
            <div className="text-charcoal/80 font-semibold" data-id="element-489">Gourmet Group</div>
          </div>
        </div>
      </div>
    </section>;
};
const CourseHighlights = () => {
  return <section className="py-12 bg-gray-50" data-id="element-490">
      <div className="container mx-auto px-4 md:px-6" data-id="element-491">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-492">
          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 flex items-start" data-id="element-493">
            <div className="w-12 h-12 rounded-full bg-teal/10 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-494">
              <LockIcon className="h-6 w-6 text-teal" data-id="element-495" />
            </div>
            <div data-id="element-496">
              <h3 className="text-lg font-bold mb-2 text-charcoal" data-id="element-497">
                Instant Access
              </h3>
              <p className="text-charcoal/70" data-id="element-498">
                Start training immediately after enrollment with our easy-to-use
                learning platform
              </p>
            </div>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 flex items-start" data-id="element-499">
            <div className="w-12 h-12 rounded-full bg-teal/10 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-500">
              <GraduationCapIcon className="h-6 w-6 text-teal" data-id="element-501" />
            </div>
            <div data-id="element-502">
              <h3 className="text-lg font-bold mb-2 text-charcoal" data-id="element-503">
                Automatic Certification
              </h3>
              <p className="text-charcoal/70" data-id="element-504">
                Receive your certificate instantly upon course completion - no
                waiting period
              </p>
            </div>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100 flex items-start" data-id="element-505">
            <div className="w-12 h-12 rounded-full bg-teal/10 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-506">
              <BarChartIcon className="h-6 w-6 text-teal" data-id="element-507" />
            </div>
            <div data-id="element-508">
              <h3 className="text-lg font-bold mb-2 text-charcoal" data-id="element-509">
                Team Management
              </h3>
              <p className="text-charcoal/70" data-id="element-510">
                Free dashboard to assign, track, and manage training for your
                entire team
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
const CourseOverview = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
      }
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  return <section ref={sectionRef} className="py-20 bg-white" data-id="element-511">
      <div className="container mx-auto px-4 md:px-6" data-id="element-512">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-513">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-teal/10 mb-4" data-id="element-514">
            <BookOpenIcon className="h-6 w-6 text-teal" data-id="element-515" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-charcoal" data-id="element-516">
            Course Overview
          </h2>
          <p className="text-xl text-charcoal/70" data-id="element-517">
            Our Level 1 Food Safety course provides essential knowledge for
            anyone who works with or around food
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center max-w-6xl mx-auto" data-id="element-518">
          <div className={`transition-all duration-700 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'}`} data-id="element-519">
            <div className="prose prose-lg max-w-none text-charcoal/80" data-id="element-520">
              <p data-id="element-521">
                The Level 1 Food Safety Certification is designed for all food
                handlers working in the food industry. This comprehensive course
                covers the fundamental principles of food safety, providing you
                with the essential knowledge to prevent contamination and ensure
                safe food handling practices.
              </p>
              <p data-id="element-522">
                Whether you're just starting your career in the food industry or
                need to fulfill compliance requirements, this course delivers
                the critical information you need in a clear, engaging format
                that's easy to understand and apply in your workplace.
              </p>
              <p data-id="element-523">
                Fully compliant with EU and UK food safety regulations, this
                certification is recognized by employers and enforcement
                officers throughout Europe, making it the perfect foundation for
                your food safety training.
              </p>
            </div>
            <div className="mt-8 grid grid-cols-2 gap-4" data-id="element-524">
              <div className="flex items-center" data-id="element-525">
                <CheckCircleIcon className="h-5 w-5 text-teal mr-3 flex-shrink-0" data-id="element-526" />
                <span data-id="element-527">Fully accredited</span>
              </div>
              <div className="flex items-center" data-id="element-528">
                <CheckCircleIcon className="h-5 w-5 text-teal mr-3 flex-shrink-0" data-id="element-529" />
                <span data-id="element-530">Internationally recognized</span>
              </div>
              <div className="flex items-center" data-id="element-531">
                <CheckCircleIcon className="h-5 w-5 text-teal mr-3 flex-shrink-0" data-id="element-532" />
                <span data-id="element-533">Valid for 3 years</span>
              </div>
              <div className="flex items-center" data-id="element-534">
                <CheckCircleIcon className="h-5 w-5 text-teal mr-3 flex-shrink-0" data-id="element-535" />
                <span data-id="element-536">Meets legal requirements</span>
              </div>
            </div>
          </div>
          <div className={`transition-all duration-700 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'} delay-200`} data-id="element-537">
            <div className="bg-gray-50 rounded-2xl overflow-hidden" data-id="element-538">
              <div className="p-8" data-id="element-539">
                <h3 className="text-xl font-bold mb-6 text-charcoal" data-id="element-540">
                  Course Details
                </h3>
                <div className="space-y-6" data-id="element-541">
                  <div className="flex" data-id="element-542">
                    <ClockIcon className="h-6 w-6 text-teal mr-4 flex-shrink-0" data-id="element-543" />
                    <div data-id="element-544">
                      <h4 className="font-bold text-charcoal mb-1" data-id="element-545">Duration</h4>
                      <p className="text-charcoal/70" data-id="element-546">
                        Approximately 2 hours to complete
                      </p>
                    </div>
                  </div>
                  <div className="flex" data-id="element-547">
                    <BookOpenIcon className="h-6 w-6 text-teal mr-4 flex-shrink-0" data-id="element-548" />
                    <div data-id="element-549">
                      <h4 className="font-bold text-charcoal mb-1" data-id="element-550">
                        Course Format
                      </h4>
                      <p className="text-charcoal/70" data-id="element-551">
                        6 interactive modules with quizzes
                      </p>
                    </div>
                  </div>
                  <div className="flex" data-id="element-552">
                    <AwardIcon className="h-6 w-6 text-teal mr-4 flex-shrink-0" data-id="element-553" />
                    <div data-id="element-554">
                      <h4 className="font-bold text-charcoal mb-1" data-id="element-555">
                        Certification
                      </h4>
                      <p className="text-charcoal/70" data-id="element-556">
                        Instant downloadable certificate
                      </p>
                    </div>
                  </div>
                  <div className="flex" data-id="element-557">
                    <ShieldCheckIcon className="h-6 w-6 text-teal mr-4 flex-shrink-0" data-id="element-558" />
                    <div data-id="element-559">
                      <h4 className="font-bold text-charcoal mb-1" data-id="element-560">
                        Compliance
                      </h4>
                      <p className="text-charcoal/70" data-id="element-561">
                        Meets EU & UK food safety regulations
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
const WhyChooseUs = () => {
  return <section className="py-20 bg-gray-50" data-id="element-562">
      <div className="container mx-auto px-4 md:px-6" data-id="element-563">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-564">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-teal/10 mb-4" data-id="element-565">
            <ThumbsUpIcon className="h-6 w-6 text-teal" data-id="element-566" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-charcoal" data-id="element-567">
            Why Choose Our Level 1 Food Safety Certification?
          </h2>
          <p className="text-xl text-charcoal/70" data-id="element-568">
            The perfect combination of quality training, industry recognition,
            and practical value
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-569">
          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100" data-id="element-570">
            <div className="w-12 h-12 rounded-full bg-teal/10 flex items-center justify-center mb-6" data-id="element-571">
              <ShieldCheckIcon className="h-6 w-6 text-teal" data-id="element-572" />
            </div>
            <h3 className="text-xl font-bold mb-3 text-charcoal" data-id="element-573">
              Industry-Recognized Certification
            </h3>
            <p className="text-charcoal/70" data-id="element-574">
              Our certificate is fully accredited and recognized by
              environmental health officers and food safety inspectors
              throughout the EU and UK, meeting all legal requirements for food
              handler training.
            </p>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100" data-id="element-575">
            <div className="w-12 h-12 rounded-full bg-teal/10 flex items-center justify-center mb-6" data-id="element-576">
              <LightbulbIcon className="h-6 w-6 text-teal" data-id="element-577" />
            </div>
            <h3 className="text-xl font-bold mb-3 text-charcoal" data-id="element-578">
              Practical, Real-World Application
            </h3>
            <p className="text-charcoal/70" data-id="element-579">
              Learn food safety principles that you can immediately apply in
              your kitchen, from proper handwashing techniques to temperature
              control and hazard prevention.
            </p>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100" data-id="element-580">
            <div className="w-12 h-12 rounded-full bg-teal/10 flex items-center justify-center mb-6" data-id="element-581">
              <BrainIcon className="h-6 w-6 text-teal" data-id="element-582" />
            </div>
            <h3 className="text-xl font-bold mb-3 text-charcoal" data-id="element-583">
              Comprehensive Knowledge Base
            </h3>
            <p className="text-charcoal/70" data-id="element-584">
              Gain complete understanding of food safety regulations, including
              biological, chemical, and physical hazards, and your legal
              responsibilities as a food handler.
            </p>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100" data-id="element-585">
            <div className="w-12 h-12 rounded-full bg-teal/10 flex items-center justify-center mb-6" data-id="element-586">
              <MessageCircleIcon className="h-6 w-6 text-teal" data-id="element-587" />
            </div>
            <h3 className="text-xl font-bold mb-3 text-charcoal" data-id="element-588">
              24/7 Support & Resources
            </h3>
            <p className="text-charcoal/70" data-id="element-589">
              Access to our support team, FAQs, and comprehensive course
              materials to help you succeed in your training.
            </p>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100" data-id="element-590">
            <div className="w-12 h-12 rounded-full bg-teal/10 flex items-center justify-center mb-6" data-id="element-591">
              <AlertCircleIcon className="h-6 w-6 text-teal" data-id="element-592" />
            </div>
            <h3 className="text-xl font-bold mb-3 text-charcoal" data-id="element-593">
              100% Acceptance Guarantee
            </h3>
            <p className="text-charcoal/70" data-id="element-594">
              If your certificate is not accepted by regulators or employers,
              we'll refund your purchase in full. No risk, no stress.
            </p>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100" data-id="element-595">
            <div className="w-12 h-12 rounded-full bg-teal/10 flex items-center justify-center mb-6" data-id="element-596">
              <UtensilsIcon className="h-6 w-6 text-teal" data-id="element-597" />
            </div>
            <h3 className="text-xl font-bold mb-3 text-charcoal" data-id="element-598">
              Kitchen-Ready Skills
            </h3>
            <p className="text-charcoal/70" data-id="element-599">
              Master essential skills like cross-contamination prevention, safe
              storage, and food preparation that directly impact food safety in
              real kitchen environments.
            </p>
          </div>
        </div>
      </div>
    </section>;
};
const LearningOutcomes = () => {
  return <section className="py-20 bg-gray-50" data-id="element-600">
      <div className="container mx-auto px-4 md:px-6" data-id="element-601">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-602">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-teal/10 mb-4" data-id="element-603">
            <CheckIcon className="h-6 w-6 text-teal" data-id="element-604" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-charcoal" data-id="element-605">
            What You'll Learn
          </h2>
          <p className="text-xl text-charcoal/70" data-id="element-606">
            By the end of this course, you'll have the essential skills and
            knowledge to handle food safely
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-607">
          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100" data-id="element-608">
            <div className="w-12 h-12 rounded-full bg-teal/10 flex items-center justify-center mb-6" data-id="element-609">
              <ShieldCheckIcon className="h-6 w-6 text-teal" data-id="element-610" />
            </div>
            <h3 className="text-xl font-bold mb-3 text-charcoal" data-id="element-611">
              Food Safety Principles
            </h3>
            <p className="text-charcoal/70" data-id="element-612">
              Understand the fundamental concepts of food safety and why they're
              critical in food handling environments
            </p>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100" data-id="element-613">
            <div className="w-12 h-12 rounded-full bg-teal/10 flex items-center justify-center mb-6" data-id="element-614">
              <BookOpenIcon className="h-6 w-6 text-teal" data-id="element-615" />
            </div>
            <h3 className="text-xl font-bold mb-3 text-charcoal" data-id="element-616">
              Legal Requirements
            </h3>
            <p className="text-charcoal/70" data-id="element-617">
              Learn about the key legislation that governs food safety in the EU
              and UK, and your responsibilities
            </p>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100" data-id="element-618">
            <div className="w-12 h-12 rounded-full bg-teal/10 flex items-center justify-center mb-6" data-id="element-619">
              <FileTextIcon className="h-6 w-6 text-teal" data-id="element-620" />
            </div>
            <h3 className="text-xl font-bold mb-3 text-charcoal" data-id="element-621">
              Hazard Awareness
            </h3>
            <p className="text-charcoal/70" data-id="element-622">
              Identify common food safety hazards including biological,
              chemical, and physical contaminants
            </p>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100" data-id="element-623">
            <div className="w-12 h-12 rounded-full bg-teal/10 flex items-center justify-center mb-6" data-id="element-624">
              <CheckIcon className="h-6 w-6 text-teal" data-id="element-625" />
            </div>
            <h3 className="text-xl font-bold mb-3 text-charcoal" data-id="element-626">
              Personal Hygiene
            </h3>
            <p className="text-charcoal/70" data-id="element-627">
              Master the essential personal hygiene practices required for safe
              food handling
            </p>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100" data-id="element-628">
            <div className="w-12 h-12 rounded-full bg-teal/10 flex items-center justify-center mb-6" data-id="element-629">
              <ClockIcon className="h-6 w-6 text-teal" data-id="element-630" />
            </div>
            <h3 className="text-xl font-bold mb-3 text-charcoal" data-id="element-631">
              Temperature Control
            </h3>
            <p className="text-charcoal/70" data-id="element-632">
              Learn proper temperature control methods to prevent bacterial
              growth and food spoilage
            </p>
          </div>
          <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100" data-id="element-633">
            <div className="w-12 h-12 rounded-full bg-teal/10 flex items-center justify-center mb-6" data-id="element-634">
              <AwardIcon className="h-6 w-6 text-teal" data-id="element-635" />
            </div>
            <h3 className="text-xl font-bold mb-3 text-charcoal" data-id="element-636">
              Cleaning & Sanitizing
            </h3>
            <p className="text-charcoal/70" data-id="element-637">
              Understand effective cleaning and sanitizing procedures to
              maintain a safe food environment
            </p>
          </div>
        </div>
      </div>
    </section>;
};
const CourseCurriculum = () => {
  const [openModule, setOpenModule] = useState(1);
  const toggleModule = moduleId => {
    setOpenModule(openModule === moduleId ? null : moduleId);
  };
  const modules = [{
    id: 1,
    title: 'Introduction to Food Safety',
    lessons: ['Why Food Safety Matters', 'Key Terminology and Concepts', 'Food Safety Statistics and Impact'],
    duration: '20 minutes'
  }, {
    id: 2,
    title: 'Food Safety Hazards',
    lessons: ['Biological Hazards and Pathogens', 'Chemical Hazards and Contamination', 'Physical Hazards and Prevention'],
    duration: '25 minutes'
  }, {
    id: 3,
    title: 'Personal Hygiene',
    lessons: ['Handwashing Techniques', 'Appropriate Workwear', 'Health Reporting Requirements'],
    duration: '20 minutes'
  }, {
    id: 4,
    title: 'Safe Food Handling',
    lessons: ['Cross-Contamination Prevention', 'Safe Storage Practices', 'Food Preparation Guidelines'],
    duration: '25 minutes'
  }, {
    id: 5,
    title: 'Cleaning and Sanitizing',
    lessons: ['Cleaning vs. Sanitizing', 'Effective Cleaning Procedures', 'Sanitizing Methods and Chemicals'],
    duration: '15 minutes'
  }, {
    id: 6,
    title: 'Legal Requirements',
    lessons: ['Food Safety Legislation Overview', 'Record Keeping Requirements', 'Responsibilities and Compliance'],
    duration: '15 minutes'
  }];
  return <section className="py-20 bg-white" data-id="element-638">
      <div className="container mx-auto px-4 md:px-6" data-id="element-639">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-640">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-teal/10 mb-4" data-id="element-641">
            <BookOpenIcon className="h-6 w-6 text-teal" data-id="element-642" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-charcoal" data-id="element-643">
            Course Curriculum
          </h2>
          <p className="text-xl text-charcoal/70" data-id="element-644">
            Our comprehensive curriculum covers all essential aspects of Level 1
            Food Safety
          </p>
        </div>
        <div className="max-w-4xl mx-auto" data-id="element-645">
          {modules.map(module => <div key={module.id} className="mb-4 border border-gray-200 rounded-xl overflow-hidden" data-id="element-646">
              <button onClick={() => toggleModule(module.id)} className="flex items-center justify-between w-full p-5 bg-white hover:bg-gray-50 transition-colors text-left" data-id="element-647">
                <div className="flex items-center" data-id="element-648">
                  <div className="w-10 h-10 rounded-full bg-teal/10 flex items-center justify-center mr-4 flex-shrink-0" data-id="element-649">
                    <span className="font-bold text-teal" data-id="element-650">{module.id}</span>
                  </div>
                  <div data-id="element-651">
                    <h3 className="text-lg font-bold text-charcoal" data-id="element-652">
                      {module.title}
                    </h3>
                    <p className="text-charcoal/60 text-sm" data-id="element-653">
                      {module.duration}
                    </p>
                  </div>
                </div>
                {openModule === module.id ? <MinusIcon className="h-5 w-5 text-teal" data-id="element-654" /> : <PlusIcon className="h-5 w-5 text-teal" data-id="element-655" />}
              </button>
              {openModule === module.id && <div className="p-5 bg-gray-50 border-t border-gray-200" data-id="element-656">
                  <ul className="space-y-3" data-id="element-657">
                    {module.lessons.map((lesson, index) => <li key={index} className="flex items-start" data-id="element-658">
                        <CheckCircleIcon className="h-5 w-5 text-teal mt-0.5 mr-3 flex-shrink-0" data-id="element-659" />
                        <span className="text-charcoal/80" data-id="element-660">{lesson}</span>
                      </li>)}
                  </ul>
                </div>}
            </div>)}
          <div className="mt-10 p-6 bg-teal/10 rounded-xl" data-id="element-661">
            <div className="flex items-start" data-id="element-662">
              <AwardIcon className="h-6 w-6 text-teal mr-4 flex-shrink-0 mt-1" data-id="element-663" />
              <div data-id="element-664">
                <h3 className="text-lg font-bold text-charcoal mb-2" data-id="element-665">
                  Final Assessment
                </h3>
                <p className="text-charcoal/70 mb-2" data-id="element-666">
                  Complete a comprehensive assessment to test your knowledge and
                  earn your certification.
                </p>
                <p className="text-charcoal/70" data-id="element-667">
                  <strong data-id="element-668">Pass Mark:</strong> 80% | <strong data-id="element-669">Time Limit:</strong>{' '}
                  30 minutes | <strong data-id="element-670">Attempts:</strong> Unlimited
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
const EnrollmentOptions = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
      }
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  return <section id="enrollment-options" ref={sectionRef} className="py-20 bg-gray-50" data-id="element-671">
      <div className="container mx-auto px-4 md:px-6" data-id="element-672">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-673">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-teal/10 mb-4" data-id="element-674">
            <UsersIcon className="h-6 w-6 text-teal" data-id="element-675" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-charcoal" data-id="element-676">
            Enrollment Options
          </h2>
          <p className="text-xl text-charcoal/70" data-id="element-677">
            Choose the enrollment option that works best for you or your team
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-678">
          <div id="individual-enrollment" className={`bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200 transition-all duration-700 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'}`} data-id="element-679">
            <div className="p-8" data-id="element-680">
              <div className="w-14 h-14 rounded-full bg-teal/10 flex items-center justify-center mb-6" data-id="element-681">
                <UserIcon className="h-7 w-7 text-teal" data-id="element-682" />
              </div>
              <h3 className="text-2xl font-bold mb-4 text-charcoal" data-id="element-683">
                Individual Enrollment
              </h3>
              <p className="text-charcoal/70 mb-6" data-id="element-684">
                Perfect for individual learners who need immediate access to
                training and certification.
              </p>
              <div className="space-y-4 mb-8" data-id="element-685">
                <div className="flex items-start" data-id="element-686">
                  <CheckCircleIcon className="h-5 w-5 text-teal mt-0.5 mr-3 flex-shrink-0" data-id="element-687" />
                  <p className="text-charcoal/80" data-id="element-688">
                    Instant access to course materials
                  </p>
                </div>
                <div className="flex items-start" data-id="element-689">
                  <CheckCircleIcon className="h-5 w-5 text-teal mt-0.5 mr-3 flex-shrink-0" data-id="element-690" />
                  <p className="text-charcoal/80" data-id="element-691">Learn at your own pace</p>
                </div>
                <div className="flex items-start" data-id="element-692">
                  <CheckCircleIcon className="h-5 w-5 text-teal mt-0.5 mr-3 flex-shrink-0" data-id="element-693" />
                  <p className="text-charcoal/80" data-id="element-694">
                    Automatic certification upon completion
                  </p>
                </div>
                <div className="flex items-start" data-id="element-695">
                  <CheckCircleIcon className="h-5 w-5 text-teal mt-0.5 mr-3 flex-shrink-0" data-id="element-696" />
                  <p className="text-charcoal/80" data-id="element-697">
                    Lifetime access to your certificate
                  </p>
                </div>
              </div>
              <div className="pt-6 border-t border-gray-100" data-id="element-698">
                <div className="flex items-end mb-6" data-id="element-699">
                  <span className="text-3xl font-bold text-charcoal" data-id="element-700">€39</span>
                  <span className="text-charcoal/60 ml-2" data-id="element-701">per person</span>
                </div>
                <a href="/checkout/individual" className="block w-full py-3 bg-teal text-white font-medium rounded-lg hover:bg-teal/90 transition-all duration-300 text-center shadow-md" data-id="element-702">
                  Enroll Now
                </a>
              </div>
            </div>
          </div>
          <div id="team-enrollment" className={`bg-charcoal rounded-xl shadow-lg overflow-hidden transition-all duration-700 transform ${isVisible ? 'translate-y-0 opacity-100' : 'translate-y-8 opacity-0'} delay-200`} data-id="element-703">
            <div className="p-8 text-white" data-id="element-704">
              <div className="w-14 h-14 rounded-full bg-white/10 flex items-center justify-center mb-6" data-id="element-705">
                <BuildingIcon className="h-7 w-7 text-aqua" data-id="element-706" />
              </div>
              <h3 className="text-2xl font-bold mb-4" data-id="element-707">
                Team & Business Enrollment
              </h3>
              <p className="text-white/80 mb-6" data-id="element-708">
                Ideal for businesses needing to train multiple employees with
                management tools included.
              </p>
              <div className="space-y-4 mb-8" data-id="element-709">
                <div className="flex items-start" data-id="element-710">
                  <CheckCircleIcon className="h-5 w-5 text-aqua mt-0.5 mr-3 flex-shrink-0" data-id="element-711" />
                  <p className="text-white/80" data-id="element-712">
                    Free manager dashboard included
                  </p>
                </div>
                <div className="flex items-start" data-id="element-713">
                  <CheckCircleIcon className="h-5 w-5 text-aqua mt-0.5 mr-3 flex-shrink-0" data-id="element-714" />
                  <p className="text-white/80" data-id="element-715">Bulk enrollment capabilities</p>
                </div>
                <div className="flex items-start" data-id="element-716">
                  <CheckCircleIcon className="h-5 w-5 text-aqua mt-0.5 mr-3 flex-shrink-0" data-id="element-717" />
                  <p className="text-white/80" data-id="element-718">
                    Progress tracking and reporting
                  </p>
                </div>
                <div className="flex items-start" data-id="element-719">
                  <CheckCircleIcon className="h-5 w-5 text-aqua mt-0.5 mr-3 flex-shrink-0" data-id="element-720" />
                  <p className="text-white/80" data-id="element-721">
                    Certificate management for all users
                  </p>
                </div>
              </div>
              <div className="pt-6 border-t border-white/10" data-id="element-722">
                <div className="mb-6" data-id="element-723">
                  <div className="flex items-end" data-id="element-724">
                    <span className="text-3xl font-bold" data-id="element-725">€39</span>
                    <span className="text-white/60 ml-2" data-id="element-726">per license</span>
                  </div>
                  <p className="text-white/60 text-sm mt-1" data-id="element-727">
                    Volume discounts available for 10+ licenses
                  </p>
                </div>
                <div className="grid grid-cols-2 gap-4" data-id="element-728">
                  <a href="/checkout/team" className="block py-3 bg-aqua text-white font-medium rounded-lg hover:bg-aqua/90 transition-all duration-300 text-center shadow-md" data-id="element-729">
                    Buy Now
                  </a>
                  <a href="/contact" className="block py-3 bg-transparent text-white font-medium rounded-lg border border-white/30 hover:bg-white/10 transition-all duration-300 text-center" data-id="element-730">
                    Contact Sales
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="max-w-5xl mx-auto mt-16 bg-white rounded-xl p-6 shadow-sm border border-gray-200" data-id="element-731">
          <h3 className="text-xl font-bold mb-4 text-charcoal" data-id="element-732">
            Volume Discounts
          </h3>
          <div className="overflow-x-auto" data-id="element-733">
            <table className="w-full" data-id="element-734">
              <thead data-id="element-735">
                <tr className="border-b border-gray-200" data-id="element-736">
                  <th className="py-3 px-4 text-left text-charcoal" data-id="element-737">
                    Number of Licenses
                  </th>
                  <th className="py-3 px-4 text-left text-charcoal" data-id="element-738">
                    Price Per License
                  </th>
                  <th className="py-3 px-4 text-left text-charcoal" data-id="element-739">Savings</th>
                </tr>
              </thead>
              <tbody data-id="element-740">
                <tr className="border-b border-gray-100" data-id="element-741">
                  <td className="py-3 px-4 text-charcoal/80" data-id="element-742">1-9</td>
                  <td className="py-3 px-4 text-charcoal/80" data-id="element-743">€39</td>
                  <td className="py-3 px-4 text-charcoal/80" data-id="element-744">-</td>
                </tr>
                <tr className="border-b border-gray-100" data-id="element-745">
                  <td className="py-3 px-4 text-charcoal/80" data-id="element-746">10-49</td>
                  <td className="py-3 px-4 text-charcoal/80" data-id="element-747">€35</td>
                  <td className="py-3 px-4 text-teal" data-id="element-748">10% off</td>
                </tr>
                <tr className="border-b border-gray-100" data-id="element-749">
                  <td className="py-3 px-4 text-charcoal/80" data-id="element-750">50-99</td>
                  <td className="py-3 px-4 text-charcoal/80" data-id="element-751">€31</td>
                  <td className="py-3 px-4 text-teal" data-id="element-752">20% off</td>
                </tr>
                <tr data-id="element-753">
                  <td className="py-3 px-4 text-charcoal/80" data-id="element-754">100+</td>
                  <td className="py-3 px-4 text-charcoal/80" data-id="element-755">€27</td>
                  <td className="py-3 px-4 text-teal" data-id="element-756">30% off</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>;
};
const CertificationSection = () => {
  return <section className="py-20 bg-white" data-id="element-757">
      <div className="container mx-auto px-4 md:px-6" data-id="element-758">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center max-w-6xl mx-auto" data-id="element-759">
          <div data-id="element-760">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-teal/10 mb-4" data-id="element-761">
              <AwardIcon className="h-6 w-6 text-teal" data-id="element-762" />
            </div>
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-charcoal" data-id="element-763">
              Recognized Certification
            </h2>
            <p className="text-lg text-charcoal/70 mb-6" data-id="element-764">
              Upon successful completion of the course and assessment, you'll
              receive an instant, downloadable certificate that's recognized
              throughout the EU and UK.
            </p>
            <div className="space-y-4 mb-8" data-id="element-765">
              <div className="flex items-start" data-id="element-766">
                <BadgeCheckIcon className="h-5 w-5 text-teal mt-0.5 mr-3 flex-shrink-0" data-id="element-767" />
                <div data-id="element-768">
                  <p className="font-medium text-charcoal" data-id="element-769">CPD Accredited</p>
                  <p className="text-charcoal/60 text-sm" data-id="element-770">
                    Meets Continuing Professional Development standards
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-771">
                <BadgeCheckIcon className="h-5 w-5 text-teal mt-0.5 mr-3 flex-shrink-0" data-id="element-772" />
                <div data-id="element-773">
                  <p className="font-medium text-charcoal" data-id="element-774">
                    Industry Recognized
                  </p>
                  <p className="text-charcoal/60 text-sm" data-id="element-775">
                    Accepted by employers and enforcement officers
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-776">
                <BadgeCheckIcon className="h-5 w-5 text-teal mt-0.5 mr-3 flex-shrink-0" data-id="element-777" />
                <div data-id="element-778">
                  <p className="font-medium text-charcoal" data-id="element-779">Valid for 3 Years</p>
                  <p className="text-charcoal/60 text-sm" data-id="element-780">
                    Industry standard validity period
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-781">
                <BadgeCheckIcon className="h-5 w-5 text-teal mt-0.5 mr-3 flex-shrink-0" data-id="element-782" />
                <div data-id="element-783">
                  <p className="font-medium text-charcoal" data-id="element-784">
                    Digital Verification
                  </p>
                  <p className="text-charcoal/60 text-sm" data-id="element-785">
                    QR code for instant certificate verification
                  </p>
                </div>
              </div>
            </div>
            <div className="flex items-center p-4 bg-teal/10 rounded-lg" data-id="element-786">
              <DownloadIcon className="h-6 w-6 text-teal mr-4" data-id="element-787" />
              <p className="text-charcoal/80" data-id="element-788">
                Your certificate is available for download immediately after
                completion
              </p>
            </div>
          </div>
          <div className="relative" data-id="element-789">
            <div className="bg-white rounded-xl shadow-xl overflow-hidden border border-gray-200" data-id="element-790">
              <img src="https://images.unsplash.com/photo-1553877522-43269d4ea984?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80" alt="Food Safety Certificate" className="w-full h-auto" data-id="element-791" />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-white p-6 rounded-xl shadow-xl border border-gray-100 max-w-xs" data-id="element-792">
              <div className="flex items-center mb-3" data-id="element-793">
                <div className="w-8 h-8 rounded-full bg-teal flex items-center justify-center mr-3" data-id="element-794">
                  <ShieldCheckIcon className="h-4 w-4 text-white" data-id="element-795" />
                </div>
                <h4 className="font-bold text-charcoal" data-id="element-796">
                  Certificate Validity Checker
                </h4>
              </div>
              <p className="text-charcoal/70 text-sm mb-3" data-id="element-797">
                Verify the authenticity of any certificate using our online
                verification tool. Simply enter the certificate ID.
              </p>
              <a href="/verify-certificate" className="block text-center py-2 px-4 bg-teal text-white font-medium rounded-md hover:bg-teal/90 transition-all duration-300 shadow-sm" data-id="element-798">
                Check Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
};
const TestimonialsSection = () => {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
      }
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  const industryBenefits = [{
    icon: <ShieldCheckIcon className="h-6 w-6 text-teal" data-id="element-799" />,
    title: 'Legal Compliance',
    description: 'Meets all EU and UK regulatory requirements for food handlers in the industry'
  }, {
    icon: <BuildingIcon className="h-6 w-6 text-teal" data-id="element-800" />,
    title: 'Industry Standard',
    description: 'Recognized by leading food service establishments and health inspectors'
  }, {
    icon: <TrendingUpIcon className="h-6 w-6 text-teal" data-id="element-801" />,
    title: 'Career Advancement',
    description: 'Enhances employment prospects and demonstrates professional commitment'
  }, {
    icon: <GraduationCapIcon className="h-6 w-6 text-teal" data-id="element-802" />,
    title: 'Knowledge Foundation',
    description: 'Creates a solid base for further specialized food safety qualifications'
  }, {
    icon: <BadgeCheckIcon className="h-6 w-6 text-teal" data-id="element-803" />,
    title: 'Quality Assurance',
    description: 'Helps businesses maintain high standards and customer confidence'
  }, {
    icon: <AwardIcon className="h-6 w-6 text-teal" data-id="element-804" />,
    title: 'International Recognition',
    description: 'Certificate accepted across multiple countries and jurisdictions'
  }];
  return <section ref={sectionRef} className="py-20 bg-gray-50" data-id="element-805">
      <div className="container mx-auto px-4 md:px-6" data-id="element-806">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-807">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-teal/10 mb-4" data-id="element-808">
            <BadgeCheckIcon className="h-6 w-6 text-teal" data-id="element-809" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-charcoal" data-id="element-810">
            Industry Recognition & Benefits
          </h2>
          <p className="text-xl text-charcoal/70" data-id="element-811">
            How this certification enhances your professional profile and
            ensures compliance
          </p>
        </div>
        <div className={`grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto transition-all duration-1000 ${isVisible ? 'opacity-100' : 'opacity-0'}`} data-id="element-812">
          {industryBenefits.map((benefit, index) => <div key={index} className="bg-white rounded-xl shadow-sm overflow-hidden border border-gray-100 hover:shadow-md transition-all duration-300" style={{
          transitionDelay: `${index * 100}ms`,
          transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
          opacity: isVisible ? 1 : 0,
          transition: 'all 0.7s ease'
        }} data-id="element-813">
              <div className="p-8" data-id="element-814">
                <div className="w-12 h-12 rounded-full bg-teal/10 flex items-center justify-center mb-5" data-id="element-815">
                  {benefit.icon}
                </div>
                <h3 className="text-xl font-bold text-charcoal mb-3" data-id="element-816">
                  {benefit.title}
                </h3>
                <p className="text-charcoal/70" data-id="element-817">{benefit.description}</p>
              </div>
            </div>)}
        </div>
        <div className="max-w-4xl mx-auto mt-16 p-8 bg-white rounded-xl shadow-lg border border-gray-100 flex flex-col md:flex-row items-center gap-8" data-id="element-818">
          <div className="flex-1" data-id="element-819">
            <div className="flex items-center mb-4" data-id="element-820">
              <div className="flex space-x-2" data-id="element-821">
                <div className="px-3 py-1 bg-teal/10 rounded-full" data-id="element-822">
                  <span className="text-teal font-medium" data-id="element-823">CPD Certified</span>
                </div>
                <div className="px-3 py-1 bg-teal/10 rounded-full" data-id="element-824">
                  <span className="text-teal font-medium" data-id="element-825">EU Compliant</span>
                </div>
                <div className="px-3 py-1 bg-teal/10 rounded-full" data-id="element-826">
                  <span className="text-teal font-medium" data-id="element-827">UK Approved</span>
                </div>
              </div>
            </div>
            <h3 className="text-2xl font-bold text-charcoal mb-2" data-id="element-828">
              Used by 10,000+ Food Businesses
            </h3>
            <p className="text-charcoal/70" data-id="element-829">
              From small cafés to major restaurant chains, our certification is
              trusted industry-wide to meet compliance requirements.
            </p>
          </div>
          <div className="flex-shrink-0" data-id="element-830">
            <a href="#enrollment-options" className="px-8 py-4 bg-teal text-white font-medium rounded-md hover:bg-gradient-to-r hover:from-teal hover:to-aqua transition-all duration-300 text-center shadow-lg inline-block" data-id="element-831">
              Get Certified Today
            </a>
          </div>
        </div>
      </div>
    </section>;
};
const FaqSection = () => {
  const [openQuestion, setOpenQuestion] = useState(null);
  const toggleQuestion = questionId => {
    setOpenQuestion(openQuestion === questionId ? null : questionId);
  };
  const faqs = [{
    id: 1,
    question: 'How long does it take to complete the Level 1 Food Safety course?',
    answer: 'The Level 1 Food Safety course typically takes around 2 hours to complete. However, as this is a self-paced course, you can take as much time as you need. You can pause your progress and return to complete it at your convenience.'
  }, {
    id: 2,
    question: 'Is this certificate recognized by enforcement officers?',
    answer: 'Yes, our Level 1 Food Safety certificate is fully accredited and recognized by environmental health officers and food safety inspectors throughout the EU and UK. It meets all legal requirements for food handler training.'
  }, {
    id: 3,
    question: 'How do I access the manager dashboard for my team?',
    answer: "When you purchase any number of licenses (even just one), you automatically get access to our manager dashboard. After checkout, you'll receive login details for the dashboard where you can assign courses, track progress, and manage certificates for your team."
  }, {
    id: 4,
    question: 'Can I buy now and enroll my team members later?',
    answer: "Absolutely! When you purchase multiple licenses, they remain in your account until you're ready to assign them. There's no expiration date for unused licenses, giving you complete flexibility to enroll team members as needed."
  }, {
    id: 5,
    question: 'How do I get my certificate after completing the course?',
    answer: 'Your certificate is generated automatically upon successful completion of the final assessment. You can download it immediately from your learner dashboard in PDF format. The certificate is also stored permanently in your account for future access.'
  }, {
    id: 6,
    question: 'What happens if someone fails the assessment?',
    answer: "We offer unlimited attempts on the final assessment at no additional cost. If a learner doesn't pass, they can review the course material and retake the assessment until they achieve the required passing score of 80%."
  }, {
    id: 7,
    question: 'How long is the Level 1 Food Safety certificate valid for?',
    answer: 'The Level 1 Food Safety certificate is valid for 3 years, which is the industry standard. After this period, a refresher course is recommended to ensure knowledge remains current with the latest regulations and best practices.'
  }, {
    id: 8,
    question: 'Can I access the course on mobile devices?',
    answer: 'Yes, our learning platform is fully responsive and works on all devices including smartphones, tablets, laptops, and desktop computers. You can start the course on one device and continue on another if needed.'
  }];
  return <section className="py-20 bg-white" data-id="element-832">
      <div className="container mx-auto px-4 md:px-6" data-id="element-833">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-834">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-teal/10 mb-4" data-id="element-835">
            <ChevronDownIcon className="h-6 w-6 text-teal" data-id="element-836" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-charcoal" data-id="element-837">
            Frequently Asked Questions
          </h2>
          <p className="text-xl text-charcoal/70" data-id="element-838">
            Find answers to common questions about our Level 1 Food Safety
            course
          </p>
        </div>
        <div className="max-w-4xl mx-auto" data-id="element-839">
          {faqs.map(faq => <div key={faq.id} className="mb-4 border border-gray-200 rounded-xl overflow-hidden" data-id="element-840">
              <button onClick={() => toggleQuestion(faq.id)} className="flex items-center justify-between w-full p-6 bg-white hover:bg-gray-50 transition-colors text-left" data-id="element-841">
                <h3 className="text-lg font-bold text-charcoal" data-id="element-842">
                  {faq.question}
                </h3>
                {openQuestion === faq.id ? <MinusIcon className="h-5 w-5 text-teal flex-shrink-0" data-id="element-843" /> : <PlusIcon className="h-5 w-5 text-teal flex-shrink-0" data-id="element-844" />}
              </button>
              {openQuestion === faq.id && <div className="p-6 bg-gray-50 border-t border-gray-200" data-id="element-845">
                  <p className="text-charcoal/80" data-id="element-846">{faq.answer}</p>
                </div>}
            </div>)}
        </div>
        <div className="max-w-4xl mx-auto mt-12 text-center" data-id="element-847">
          <p className="text-charcoal/70 mb-4" data-id="element-848">
            Still have questions? We're here to help.
          </p>
          <a href="/contact" className="inline-flex items-center font-medium text-teal hover:text-aqua transition-colors" data-id="element-849">
            Contact our support team
            <ChevronRightIcon className="ml-1 h-5 w-5" data-id="element-850" />
          </a>
        </div>
      </div>
    </section>;
};
const CtaSection = () => {
  return <section className="py-20 bg-gradient-to-br from-teal to-teal/90 relative overflow-hidden" data-id="element-851">
      <div className="absolute inset-0 overflow-hidden" data-id="element-852">
        <div className="absolute top-1/4 right-1/4 w-96 h-96 rounded-full bg-white/10 blur-3xl" data-id="element-853"></div>
        <div className="absolute bottom-1/4 left-1/4 w-96 h-96 rounded-full bg-white/5 blur-3xl" data-id="element-854"></div>
      </div>
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-855">
        <div className="max-w-4xl mx-auto text-center" data-id="element-856">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-white/10 mb-6" data-id="element-857">
            <CreditCardIcon className="h-8 w-8 text-white" data-id="element-858" />
          </div>
          <h2 className="text-4xl font-bold mb-6 text-white tracking-tight" data-id="element-859">
            Start Your Food Safety Training Today
          </h2>
          <p className="text-xl text-white/80 mb-10 max-w-3xl mx-auto" data-id="element-860">
            Join thousands of food industry professionals who have earned their
            certification with our comprehensive, easy-to-follow training.
          </p>
          <div className="flex flex-col sm:flex-row gap-5 justify-center" data-id="element-861">
            <a href="#individual-enrollment" className="px-8 py-4 bg-white text-teal font-medium rounded-lg hover:bg-gray-100 transition-all duration-300 shadow-lg" data-id="element-862">
              Enroll Now
            </a>
            <a href="#team-enrollment" className="px-8 py-4 bg-transparent text-white font-medium rounded-lg border-2 border-white hover:bg-white/10 transition-all duration-300" data-id="element-863">
              Team Training Options
            </a>
          </div>
          <div className="mt-10 flex flex-wrap justify-center gap-10" data-id="element-864">
            <div className="flex flex-col items-center" data-id="element-865">
              <div className="text-white/80 mb-2" data-id="element-866">Instant Access</div>
              <div className="text-white font-medium" data-id="element-867">Start Today</div>
            </div>
            <div className="flex flex-col items-center" data-id="element-868">
              <div className="text-white/80 mb-2" data-id="element-869">Fully Accredited</div>
              <div className="text-white font-medium" data-id="element-870">CPD Certified</div>
            </div>
            <div className="flex flex-col items-center" data-id="element-871">
              <div className="text-white/80 mb-2" data-id="element-872">Secure Payment</div>
              <div className="text-white font-medium" data-id="element-873">256-bit SSL</div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};